import { jsx, jsxs } from "react/jsx-runtime";
import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "../../contexts/theme-context.js";
function ThemeToggle({
  className = "",
  showLabels = false,
  variant = "icon",
  labels = {}
}) {
  const { theme, setTheme, actualTheme } = useTheme();
  const defaultLabels = {
    light: "Light",
    dark: "Dark",
    system: "System",
    selector: "Theme selector",
    tooltip: `Current: ${theme}. Click to switch.`
  };
  const finalLabels = { ...defaultLabels, ...labels };
  if (variant === "dropdown") {
    return /* @__PURE__ */ jsx("div", { className: `relative inline-block text-left ${className}`, children: /* @__PURE__ */ jsxs(
      "select",
      {
        value: theme,
        onChange: (e) => setTheme(e.target.value),
        className: "theme-toggle pr-8 pl-3 py-2 text-sm font-medium appearance-none cursor-pointer",
        "aria-label": finalLabels.selector,
        children: [
          /* @__PURE__ */ jsx("option", { value: "light", children: finalLabels.light }),
          /* @__PURE__ */ jsx("option", { value: "dark", children: finalLabels.dark }),
          /* @__PURE__ */ jsx("option", { value: "system", children: finalLabels.system })
        ]
      }
    ) });
  }
  const handleToggle = () => {
    if (theme === "light") {
      setTheme("dark");
    } else if (theme === "dark") {
      setTheme("system");
    } else {
      setTheme("light");
    }
  };
  const getIcon = () => {
    if (theme === "system") {
      return /* @__PURE__ */ jsx(Monitor, { className: "w-4 h-4" });
    }
    return actualTheme === "dark" ? /* @__PURE__ */ jsx(Moon, { className: "w-4 h-4" }) : /* @__PURE__ */ jsx(Sun, { className: "w-4 h-4" });
  };
  const getLabel = () => {
    if (theme === "system") {
      return finalLabels.system;
    }
    return actualTheme === "dark" ? finalLabels.dark : finalLabels.light;
  };
  return /* @__PURE__ */ jsx(
    "button",
    {
      onClick: handleToggle,
      className: `theme-toggle ${showLabels ? "px-3 py-2" : ""} ${className}`,
      title: finalLabels.tooltip,
      "aria-label": finalLabels.tooltip,
      children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        getIcon(),
        showLabels && /* @__PURE__ */ jsx("span", { className: "text-xs font-medium hidden sm:inline", children: getLabel() })
      ] })
    }
  );
}
export {
  ThemeToggle,
  ThemeToggle as default
};
//# sourceMappingURL=theme-toggle.js.map
